import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=60e840cf&scoped=true&"
import script from "./CatalogList.vue?vue&type=script&lang=js&"
export * from "./CatalogList.vue?vue&type=script&lang=js&"
import style0 from "./CatalogList.vue?vue&type=style&index=0&id=60e840cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e840cf",
  null
  
)

export default component.exports